import { STATES } from './states';
import { EVENTS } from './events';
import { defaultContext } from './actions';

export const machineConfig = {
  id: 'simplified-sign-up-suggestions-state-machine',
  initial: STATES.INIT,
  context: defaultContext,
  preserveActionOrder: true,
  predictableActionArguments: true,
  states: {
    [STATES.INIT]: {
      on: {
        [EVENTS.LOAD]: {
          target: STATES.LOADING,
          actions: ['updateInputs'],
        },
      },
    },
    [STATES.LOADING]: {
      type: 'parallel',
      states: {
        [STATES.RSA]: {
          initial: STATES.NEEDS_RSA,
          states: {
            [STATES.NEEDS_RSA]: {
              always: [
                { target: STATES.RSA_LOADING, cond: 'needsRSA' },
                { target: STATES.RSA_DONE },
              ],
            },
            [STATES.RSA_LOADING]: {
              invoke: {
                src: 'loadRSASuggestions',
                onDone: {
                  target: STATES.RSA_DONE,
                  actions: ['assignRSAData'],
                },
                onError: {
                  target: STATES.RSA_DONE,
                },
              },
            },
            [STATES.RSA_DONE]: {
              type: 'final',
              entry: ['markRSADone'],
            },
          },
        },
        [STATES.TEXT_ADS]: {
          initial: STATES.NEEDS_TEXT_ADS,
          states: {
            [STATES.NEEDS_TEXT_ADS]: {
              always: [
                { target: STATES.TEXT_ADS_LOADING, cond: 'needsTextAds' },
                { target: STATES.TEXT_ADS_DONE },
              ],
            },
            [STATES.TEXT_ADS_LOADING]: {
              invoke: {
                src: 'loadTextAdsSuggestions',
                onDone: {
                  target: STATES.TEXT_ADS_DONE,
                  actions: ['assignTextAdsData'],
                },
                onError: {
                  target: STATES.TEXT_ADS_DONE,
                },
              },
            },
            [STATES.TEXT_ADS_DONE]: {
              type: 'final',
              entry: ['markTextAdsDone'],
            },
          },
        },
        [STATES.IMAGE_ADS]: {
          initial: STATES.NEEDS_IMAGE_ADS,
          states: {
            [STATES.NEEDS_IMAGE_ADS]: {
              always: [
                { target: STATES.IMAGE_ADS_LOADING, cond: 'needsImageAds' },
                { target: STATES.IMAGE_ADS_DONE },
              ],
            },
            [STATES.IMAGE_ADS_LOADING]: {
              invoke: {
                src: 'loadImageAdsSuggestions',
                onDone: {
                  target: STATES.IMAGE_ADS_DONE,
                  actions: ['assignImageAdsData'],
                },
                onError: {
                  target: STATES.IMAGE_ADS_DONE,
                },
              },
            },
            [STATES.IMAGE_ADS_DONE]: {
              entry: ['markImageAdsDone'],
              type: 'final',
            },
          },
        },
        [STATES.IMAGES]: {
          initial: STATES.NEEDS_IMAGES,
          states: {
            [STATES.NEEDS_IMAGES]: {
              always: [
                { target: STATES.IMAGES_LOADING, cond: 'needsImages' },
                { target: STATES.IMAGES_DONE },
              ],
            },
            [STATES.IMAGES_LOADING]: {
              invoke: {
                src: 'loadImagesSuggestions',
                onDone: {
                  target: STATES.IMAGES_DONE,
                  actions: ['assignImagesData'],
                },
                onError: {
                  target: STATES.IMAGES_DONE,
                },
              },
            },
            [STATES.IMAGES_DONE]: {
              entry: ['markImagesDone'],
              type: 'final',
            },
          },
        },
        [STATES.BUDGET]: {
          initial: STATES.NEEDS_TARGETS,
          states: {
            [STATES.NEEDS_TARGETS]: {
              always: [
                { target: STATES.TARGETS_LOADING, cond: 'needsTargets' },
                { target: STATES.NEEDS_KEYWORDS },
              ],
            },
            [STATES.TARGETS_LOADING]: {
              invoke: {
                src: 'loadTargetsSuggestions',
                onDone: {
                  target: STATES.KEYWORDS_LOADING,
                  actions: ['assignTargetsData'],
                },
                onError: {
                  target: STATES.KEYWORDS_LOADING,
                },
              },
            },
            [STATES.NEEDS_KEYWORDS]: {
              always: [
                { target: STATES.KEYWORDS_LOADING, cond: 'needsKeywords' },
                { target: STATES.BUDGET_LOADING },
              ],
            },
            [STATES.KEYWORDS_LOADING]: {
              entry: ['markTargetsDone'],
              invoke: {
                src: 'loadKeywordsSuggestions',
                onDone: {
                  target: STATES.BUDGET_LOADING,
                  actions: ['assignKeywordsData'],
                },
                onError: {
                  target: STATES.BUDGET_LOADING,
                },
              },
            },
            [STATES.BUDGET_LOADING]: {
              entry: ['markKeywordsDone'],
              invoke: {
                src: 'loadBudgetSuggestions',
                onDone: {
                  target: STATES.BUDGET_DONE,
                  actions: ['assignBudgetData', 'markBudgetDone'],
                },
                onError: {
                  target: STATES.BUDGET_DONE,
                  actions: ['markBudgetDone'],
                },
              },
            },
            [STATES.BUDGET_DONE]: {
              entry: ['markBudgetDone'],
              type: 'final',
            },
          },
        },
        [STATES.BI]: {
          initial: STATES.BI_LOADING,
          states: {
            [STATES.BI_LOADING]: {
              invoke: {
                src: 'loadBISuggestions',
                onDone: {
                  target: STATES.BI_DONE,
                  actions: ['assignBIData'],
                },
                onError: {
                  target: STATES.BI_DONE,
                },
              },
            },
            [STATES.BI_DONE]: {
              entry: ['markBIDone'],
              type: 'final',
            },
          },
        },
      },
      onDone: STATES.DONE,
    },
    [STATES.DONE]: {
      entry: ['markAllFlagsDone'],
      on: {
        [EVENTS.LOAD]: STATES.LOADING,
      },
    },
  },
  on: {
    [EVENTS.START_OVER]: {
      actions: ['resetFlags', 'resetOutputs', 'updateInputs', 'updateOutputs'],
      target: STATES.LOADING,
    },
  },
};
